const LANDING_UTM_KEY = 'landingUtm';

// utm이 있는 진입만 덮어쓴다 — 본인인증·로그인 리다이렉트 복귀가 원래 유입을 지우지 않게
export const saveLandingUtm = (searchParams: URLSearchParams) => {
  const utm = Object.fromEntries(
    [...searchParams].filter(
      ([key, value]) => key.startsWith('utm_') && value !== '',
    ),
  );

  if (Object.keys(utm).length === 0) {
    return;
  }

  sessionStorage.setItem(LANDING_UTM_KEY, JSON.stringify(utm));
};

export const readLandingUtm = (): Record<string, string> | undefined => {
  const stored = sessionStorage.getItem(LANDING_UTM_KEY);

  if (!stored) {
    return undefined;
  }

  try {
    return JSON.parse(stored);
  } catch {
    return undefined;
  }
};
